import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PopoverModule  } from 'ngx-bootstrap/popover';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule            } from '@angular/material/card';
import { MatIconModule            } from '@angular/material/icon';
import { MatToolbarModule         } from '@angular/material/toolbar';
import { MatButtonModule          } from '@angular/material/button';
import { MatFormFieldModule       } from '@angular/material/form-field';
import { MatInputModule           } from '@angular/material/input';
import { MatSidenavModule         } from '@angular/material/sidenav';
import { MatCheckboxModule        } from '@angular/material/checkbox';
import { MatNativeDateModule      } from '@angular/material/core';
import { MatListModule            } from '@angular/material/list';
import { MatTreeModule            } from '@angular/material/tree';
import { MatRadioModule           } from '@angular/material/radio';
import { MatMenuModule            } from '@angular/material/menu';
import { MatProgressBarModule     } from '@angular/material/progress-bar';
import { MatTooltipModule         } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Routes, RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { DashboardComponent, DriveConnectDialogComponent } from './components/dashboard/dashboard.component';
import { FlowInformationComponent, TroubleshootingDialogComponent } from './components/flow-information/flow-information.component';
import { TileComponent } from './components/tile/tile.component';
import { FlowInformationService } from './components/flow-information/flow-information.service';
import { TranslateModule } from '@ngx-translate/core';
import { TCCPHttpServiceModule } from './services/tccp-http.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { LoaderService } from './loader/loader.service';
import { NotesComponent } from './components/notes/notes.component';
import { ImageVideoCarouselComponent } from './components/image-video-carousel/image-video-carousel.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BreadcrumbService } from './components/breadcrumb/breadcrumb.service';
import { TCCPCommonService } from './services/tccp-common.service';
import { PopoutService } from './services/tccp-popout.service';
import { TCCPLocalStorageService } from './services/tccp-local-storage.service';
import { DashboardService } from './components/dashboard/dashboard.service';
import { LoaderComponent } from '../shared/loader/loader.component';
import { FeedbackComponent, FeedbackDialogComponent } from './components/feedback/feedback.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { capitalizeStr } from './filters/titlecase.pipe';
import { filterUnique } from './filters/distinct.pipe';
import { KeysPipe } from './filters/keyvalue.pipe';
import { SortPipe } from './filters/sortorder.pipe';
import { HighlightPipe } from './filters/highlight.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResourcesVideosComponent } from './components/resources-videos/resources-videos.component';
import { FooterResourcesComponent } from './components/footer-resources/footer-resources.component';
import { PopupModalComponent } from './components/popup-modal/popup-modal.component';
import { PhoneManufacturerComponent } from './components/phone-manufacturer/phone-manufacturer.component';
import { PhoneCompatabilityComponent } from './components/phone-compatability/phone-compatability.component';
import { SafeHtmlPipe } from '../shared/filters/safehtml.pipe';
import { CompatibleIconsComponent } from './components/compatible-icons/compatible-icons.component';
import { ReviewCommentsComponent, ReviewCommentsDialogComponent } from './components/review-comments/review-comments.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { ErrorGuideTableComponent } from './components/error-guide-table/error-guide-table.component';
import { AlertModelComponent } from './components/alert-model/alert-model.component';
import { MatSelectModule } from '@angular/material/select';
import { OutSideClickDirective } from './directives/out-side-click.directive';
import { BadgeComponent } from './components/badge/badge.component';
import { VideoPlayerDialogComponent } from './components/video-player-dialog/video-player-dialog.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { OrientationDirective } from './directives/orientation.directive';
import { BannerComponent } from './components/banner/banner.component';
import { PreviewImageComponent } from './components/preview-image/preview-image.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { FaqComponent, FAQDialogComponent } from './components/faq/faq.component';
import { CarouselDialogComponent } from './components/image-video-carousel/carousel-dialog/carousel-dialog.component';
import { PinchZoomModule } from '@meddv/ngx-pinch-zoom';
import { HomeHeaderComponent } from './components/home-header/home-header.component';
import { HomeCarouselComponent } from './components/home-carousel/home-carousel.component';
import { ResourcesContainerComponent } from './components/resources-container/resources-container.component';
import { ModeYearVinSelectionComponent } from './components/mode-year-vin-selection/mode-year-vin-selection.component';
import { FirstSetupComponent, FirstSetupDialogComponent } from './components/first-setup/first-setup.component';
import { BtCompatabilityComponent } from './components/bt-compatability/bt-compatability.component';

const routes: Routes = [{
  path: '',
  component: PageNotFoundComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes),
    YouTubePlayerModule,
    CommonModule, TranslateModule, NgbModule, FontAwesomeModule, StorageServiceModule,
    FormsModule, ReactiveFormsModule, PopoverModule.forRoot(), MatCardModule, MatIconModule, MatToolbarModule, MatButtonModule,
    MatFormFieldModule, MatInputModule, MatSidenavModule, MatCheckboxModule, MatNativeDateModule,
    MatListModule, MatTreeModule, MatRadioModule, MatMenuModule, MatProgressBarModule,
    MatProgressSpinnerModule, MatTooltipModule, MatExpansionModule, MatTableModule, MatSnackBarModule
    , MatBadgeModule, MatDividerModule, MatSortModule, MatPaginatorModule,
  CarouselModule.forRoot(), TCCPHttpServiceModule, MatDialogModule, MatSelectModule, MatAutocompleteModule,
    MatTooltipModule, MatGridListModule, NgxPaginationModule, PinchZoomModule

  ],
  declarations: [
    HeaderComponent, FooterComponent, FeedbackComponent, FlowInformationComponent, NotesComponent, TileComponent, LoaderComponent,
    BreadcrumbComponent, DashboardComponent, ImageVideoCarouselComponent, PageNotFoundComponent,
    capitalizeStr, ConfirmModalComponent, KeysPipe, SortPipe, filterUnique, HighlightPipe,
    ResourcesVideosComponent, FooterResourcesComponent, PhoneManufacturerComponent, PhoneCompatabilityComponent,
    PopupModalComponent, SafeHtmlPipe, CompatibleIconsComponent, FeedbackDialogComponent, ReviewCommentsComponent,
    ReviewCommentsDialogComponent, TroubleshootingDialogComponent, DialogComponent,
    ErrorGuideTableComponent, AlertModelComponent, OutSideClickDirective, BadgeComponent,
    VideoPlayerDialogComponent, OrientationDirective, BannerComponent, PreviewImageComponent, FAQDialogComponent,
    ProgressBarComponent, SearchResultsComponent, SearchBarComponent, SearchPageComponent, FaqComponent, CarouselDialogComponent,
    HomeHeaderComponent, HomeCarouselComponent, ResourcesContainerComponent, ModeYearVinSelectionComponent,
    DriveConnectDialogComponent, FirstSetupComponent, FirstSetupDialogComponent, BtCompatabilityComponent
  ],
  exports: [RouterModule,
    HeaderComponent, FooterComponent, FeedbackComponent, TileComponent, LoaderComponent,
    BreadcrumbComponent, DashboardComponent,
    ImageVideoCarouselComponent, PageNotFoundComponent, FlowInformationComponent, KeysPipe, SortPipe, filterUnique, HighlightPipe,
    FooterResourcesComponent, PhoneManufacturerComponent, PhoneCompatabilityComponent,
    CompatibleIconsComponent, capitalizeStr, FeedbackDialogComponent, ReviewCommentsComponent,
    TroubleshootingDialogComponent, ErrorGuideTableComponent, AlertModelComponent,
    OutSideClickDirective, VideoPlayerDialogComponent, BannerComponent, PreviewImageComponent,
    FAQDialogComponent, SearchResultsComponent, FaqComponent, CarouselDialogComponent, HomeHeaderComponent,
    HomeCarouselComponent, ModeYearVinSelectionComponent, DriveConnectDialogComponent, FirstSetupComponent
    , FirstSetupDialogComponent],
  providers: [TCCPCommonService, FlowInformationService, DashboardService,
    LoaderService, BreadcrumbService, TCCPLocalStorageService, PopoutService, { provide: MAT_DIALOG_DATA, useValue: {} }],
  entryComponents: [ConfirmModalComponent, PopupModalComponent, FeedbackDialogComponent,
    TroubleshootingDialogComponent, ReviewCommentsDialogComponent, DialogComponent,
    AlertModelComponent, VideoPlayerDialogComponent, PreviewImageComponent, FAQDialogComponent,
    DriveConnectDialogComponent, CarouselDialogComponent, FirstSetupDialogComponent]
})
export class SharedModule { }
